import React, { useEffect, useState } from "react";

import Backdrop from "../components/UI/Backdrop/Backdrop";
import Message from "../components/Message/Message";
import Navbar from "../components/Navbar/Navbar";
import * as moment from "moment";

import { Link } from "react-router-dom";
import { useHistory } from "react-router";

import firebase from "../firebase";
import { AlertModal } from "../components/AlertModal";
import { useAuth } from "../contexts/AuthContext";
import { AppConstants } from "../common/AppConstants";

const EditUserScreen = ({ match }) => {
  const userId = match.params.id;

  var db = firebase.firestore();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    function getUserData() {
      setLoading(true);
      db.collection("users")
        .doc(userId)
        .get()
        .then((doc) => {
          let data = doc.data();
          setFirstName(data.firstName);
          setLastName(data.lastName);
          setGender(data.gender);
          setDateOfBirth(moment(data.dob, "DD/MM/YYYY").format("YYYY-MM-DD"));
          setEmail(data.email);
          setMobileNo(data.userId);
          setLoading(false);
        });
    }
    getUserData();
  }, [db, userId]);

  const onPressButton = () => {
    setShowMessage(false);
  };

  const updateUser = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    var docRef = db.collection("users").doc(userId);

    docRef
      .update({
        hrRequest: {
          firstName: firstName,
          lastName: lastName,
          gender: gender,
          dob: dateOfBirth,
          email: email,
          userId: mobileNo,
        },
        operation: AppConstants.UPDATE,
        requestBy: currentUser.email,
        status: "pending",
        updatedAt: Date.now(),
      })
      .then(() => {
        setShowMessage(true);
        setSuccessMessage(
          `Your request to update employee information for ${
            firstName + " " + lastName
          } has been submitted successfully! Our customer service team will get in touch with you within 24 hours`
        );
        setLoading(false);
      })
      .catch((error) => {
        setErrorMessage("Error updating user");
        setLoading(false);
      });
  };

  const setGenderVal = (val) => {
    setGender(val);
  };

  return (
    <div>
      <Navbar />
      <div className="add-employee" style={{ height: "90vh" }}>
        <div className="container">
          {loading && <Backdrop />}

          <Link
            onClick={() => {
              history.goBack();
            }}
            className="d-flex justify-content-between align-items-center mt-4"
            style={{
              color: "#0e4da4",
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            {`< HR Dashboard`}
          </Link>

          <div className="main">
            <h4>Edit Employee Details</h4>

            {errorMessage && <Message variant="danger">{errorMessage}</Message>}
            {successMessage && (
              <Message variant="success">{successMessage}</Message>
            )}

            <section className="form-container">
              <div className="field-box">
                <text className="label">
                  Account Holder First Name<span className="label-span">*</span>
                </text>
                <input
                  type="text"
                  required
                  className="input-box"
                  value={firstName}
                  style={styles.inputTextStyle("black")}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="field-box">
                <text className="label">
                  Account Holder Last Name<span className="label-span">*</span>
                </text>
                <input
                  type="text"
                  required
                  className="input-box"
                  value={lastName}
                  style={styles.inputTextStyle("black")}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
              <div className="field-box">
                <text className="label">E-mail Address</text>
                <input
                  type="email"
                  className="input-box"
                  value={email}
                  style={styles.inputTextStyle("black")}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="field-box">
                <text className="label">
                  Account Holder Mobile Number
                  <span className="label-span">*</span>
                </text>
                <input
                  type="number"
                  required
                  className="input-box"
                  style={styles.inputTextStyle("black")}
                  value={mobileNo}
                  onChange={(e) => setMobileNo(e.target.value)}
                />
              </div>
              <div className="field-box">
                <text className="label">
                  Account Holder Date of Birth
                  <span className="label-span">*</span>
                </text>
                <input
                  type="date"
                  style={styles.inputTextStyle(
                    dateOfBirth !== "" ? "black" : "rgba(62, 74, 89, 0.5)"
                  )}
                  required
                  className="input-box"
                  value={dateOfBirth}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                />
              </div>
              <div className="field-box">
                <text className="label">
                  Account Holder Gender<span className="label-span">*</span>
                </text>

                <select
                  name="gender"
                  id="gender"
                  className="input-box"
                  style={styles.inputTextStyle("black")}
                  value={gender}
                  onChange={(e) => {
                    setGenderVal(e.target.value);
                  }}
                >
                  <option value="Select">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                </select>
              </div>
            </section>

            {showMessage ? null : (
              <div className="text-center mt-4">
                <button
                  type="button"
                  className="upload-button"
                  disabled={loading}
                  onClick={updateUser}
                >
                  Submit Modifications to Database
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  inputTextStyle: (dateOfBirth) => ({
    color: dateOfBirth,
  }),
};

export default EditUserScreen;
